import 'css-chunk:src/pages/App/App.module.scss';export default {
  "App": "App-module__App___KqRm8",
  "modeLink": "App-module__modeLink___uCUXd",
  "infoWithButtons": "App-module__infoWithButtons___lzQ4c"
};